import { observer } from "mobx-react-lite";
import React from "react";
import { INoteButton } from "../../app/models/toolbar";
import ContentNoteButton from "../buttons/ContentNoteButton";
import FileNoteButton from "../buttons/FileNoteButton";

interface IParams {
  buttons: INoteButton[];
}

const NoteButtonsContainer: React.FC<IParams> = ({ buttons }) => {
  const renderButton = (button: INoteButton) => {
    switch (button.type) {
      case "content":
        return <ContentNoteButton key={button.type} button={button} />;
      case "file":
        return <FileNoteButton key={button.type} button={button} />;
      default:
        break;
    }
  };

  return (
    <>
      {buttons.map((b, index) => (
        <div key={index} className="mr-1" style={{ width: "60px" }}>{renderButton(b)}</div>
      ))}
    </>
  );
};

export default observer(NoteButtonsContainer);
